import { Type } from '@sinclair/typebox';
import { match, P } from 'ts-pattern';
export var SupportedNetwork;
(function (SupportedNetwork) {
    SupportedNetwork["Sol"] = "sol";
    SupportedNetwork["Ton"] = "ton";
    SupportedNetwork["Eth"] = "eth";
    SupportedNetwork["Base"] = "base";
    SupportedNetwork["Bsc"] = "bsc";
})(SupportedNetwork || (SupportedNetwork = {}));
export const NATIVE_DECIMALS_BY_NETWORK = {
    [SupportedNetwork.Sol]: 9,
    [SupportedNetwork.Ton]: 9,
    [SupportedNetwork.Eth]: 18,
    [SupportedNetwork.Base]: 18,
    [SupportedNetwork.Bsc]: 18,
};
export var FullNameSupportedNetwork;
(function (FullNameSupportedNetwork) {
    FullNameSupportedNetwork["Sol"] = "solana";
    FullNameSupportedNetwork["Ton"] = "ton";
    FullNameSupportedNetwork["Eth"] = "ethereum";
    FullNameSupportedNetwork["Base"] = "base";
    FullNameSupportedNetwork["Bsc"] = "bsc";
})(FullNameSupportedNetwork || (FullNameSupportedNetwork = {}));
export const getFullNameSupportedNetwork = (network) => {
    return match(network)
        .with(SupportedNetwork.Sol, () => FullNameSupportedNetwork.Sol)
        .with(SupportedNetwork.Ton, () => FullNameSupportedNetwork.Ton)
        .with(SupportedNetwork.Eth, () => FullNameSupportedNetwork.Eth)
        .with(SupportedNetwork.Base, () => FullNameSupportedNetwork.Base)
        .with(SupportedNetwork.Bsc, () => FullNameSupportedNetwork.Bsc)
        .exhaustive();
};
export const SupportedEvmNetworkUnion = P.union(SupportedNetwork.Eth, SupportedNetwork.Base, SupportedNetwork.Bsc);
export const parseSupportedNetwork = (network) => {
    return match(network)
        .with('sol', () => SupportedNetwork.Sol)
        .with('ton', () => SupportedNetwork.Ton)
        .with('eth', () => SupportedNetwork.Eth)
        .with('base', () => SupportedNetwork.Base)
        .with('bsc', () => SupportedNetwork.Bsc)
        .otherwise(() => {
        throw new Error(`Unsupported network: ${network}`);
    });
};
export const stringifySupportedNetwork = (network) => match(network)
    .with(SupportedNetwork.Sol, () => 'sol')
    .with(SupportedNetwork.Ton, () => 'ton')
    .with(SupportedNetwork.Eth, () => 'eth')
    .with(SupportedNetwork.Base, () => 'base')
    .with(SupportedNetwork.Bsc, () => 'bsc')
    .exhaustive();
export const isEvmNetwork = (network) => network === SupportedNetwork.Eth ||
    network === SupportedNetwork.Base ||
    network === SupportedNetwork.Bsc;
export const isSupportedNetwork = (network) => network === SupportedNetwork.Sol ||
    network === SupportedNetwork.Ton ||
    network === SupportedNetwork.Eth ||
    network === SupportedNetwork.Base ||
    network === SupportedNetwork.Bsc;
export const SupportedNetworkSchema = Type.Enum(SupportedNetwork);
export const SupportedEvmNetworkSchema = Type.Union([
    Type.Literal(SupportedNetwork.Eth),
    Type.Literal(SupportedNetwork.Base),
    Type.Literal(SupportedNetwork.Bsc),
], {
    enum: ['sol', 'ton', 'eth', 'base', 'bsc'],
});
//# sourceMappingURL=supported-network.js.map